<template>
  <div class="main-content">
    <b-container fluid class="header pt-5 mb-3">
      <b-container class="pt-5">
        <b-nav tabs fill>
          <b-nav-item :to="'/area-riservata/piani'" :disabled="!isProfileConfirmed">Il mio piano</b-nav-item>
          <b-nav-item :to="'/area-riservata/richieste'" :disabled="!isProfileConfirmed">Le mie richieste</b-nav-item>
          <b-nav-item :to="'/area-riservata/tickets'" v-if="isAdmin" :disabled="!isProfileConfirmed">Le richieste dei dipendenti</b-nav-item>
          <b-nav-item :to="'/area-riservata/profilo'" :disabled="!isProfileConfirmed">Il mio profilo</b-nav-item>
        </b-nav>
      </b-container>
    </b-container>

    <b-container>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </b-container>
  </div>
</template>

<script>
  import {mapActions, mapState, mapGetters} from 'vuex';

  export default {
    name: 'Base',
    data: () => ({}),
    computed: {
      ...mapState({
        user: state => state.user,
        plans: state => state.plans,
        devices: state => state.devices,
      }),
      ...mapGetters([
        'isAdmin',
        'isProfileConfirmed'
      ])
    },

    mounted() {
      this.getData();
    },

    methods: {
      ...mapActions([
        'getProfile',
        'getDevices',
        'getPlans',
        'getTickets',
      ]),

      async getData() {
        let loader = this.$loading.show();
        try {
          await Promise.all([
            this.getProfile(),
            this.getDevices(),
            this.getPlans(),
            this.getTickets(),
          ]);

          loader.hide();
        } catch (err) {
          loader.hide();
          this.$toastr.warning('Si è verificato un errore nel caricamento dei dati.');
        }
      },
    }
  };
</script>

<style scoped>
  .header {
    font-size: 125%;
  }

  .header a {
    color: #393939;
  }
</style>



// WEBPACK FOOTER //
// src/pages/AreaRiservata/Base.vue